import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { BuildingIcon, UsersIcon } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const Route = createFileRoute("/admin/")({
	component: AdminDashboard,
	ssr: false,
});

function AdminDashboard() {
	const { data: stats } = useSuspenseQuery({
		queryKey: ["admin", "stats"],
		queryFn: async () => {
			const response = await fetch("/api/admin/stats");
			if (!response.ok) {
				throw new Error("Failed to fetch stats");
			}
			return response.json();
		},
	});

	const statCards = [
		{
			title: "Total Organizations",
			value: stats?.organizations || 0,
			icon: BuildingIcon,
		},
		{
			title: "Total Users",
			value: stats?.users || 0,
			icon: UsersIcon,
		},
	];

	return (
		<div className="space-y-6">
			<div>
				<h1 className="font-bold text-3xl">Admin Dashboard</h1>
				<p className="text-muted-foreground">
					Manage organizations, users, and system settings
				</p>
			</div>

			<div className="grid gap-4 md:grid-cols-2">
				{statCards.map((stat) => {
					const Icon = stat.icon;
					return (
						<Card key={stat.title}>
							<CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
								<CardTitle className="font-medium text-sm">
									{stat.title}
								</CardTitle>
								<Icon className="h-4 w-4 text-muted-foreground" />
							</CardHeader>
							<CardContent>
								<div className="font-bold text-2xl">{stat.value}</div>
							</CardContent>
						</Card>
					);
				})}
			</div>
		</div>
	);
}
